import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { CompositionEvent } from './composition-events';

@Injectable({ providedIn: 'root' })
export class CompositionEventProvider extends DomainEventProvider<CompositionEvent> {}
